import { GlobalAxios } from "./../axios/axios-config";
import {
  INewAppointmentArrivalConfig,
  IAppointmentArrivalConfig,
} from "../models/appointment-arrival-config";

const APPOINTMENT_ARRIVAL_CONFIG_ROUTE =
  process.env.REACT_APP_AUTOMATIONS + "/api/v1/AppointmentArrivalRuleConfig/";

export const createAppointmentArrivalConfig = (
  item: INewAppointmentArrivalConfig,
) => {
  return GlobalAxios.post(APPOINTMENT_ARRIVAL_CONFIG_ROUTE, item);
};

export const getAppointmentArrivalConfigById = (id: string) => {
  return GlobalAxios.get<IAppointmentArrivalConfig>(
    APPOINTMENT_ARRIVAL_CONFIG_ROUTE + id,
  );
};

export const updateAppointmentArrivalConfigById = ({
  item,
  id,
}: {
  item: INewAppointmentArrivalConfig;
  id: string;
}) => {
  return GlobalAxios.put(APPOINTMENT_ARRIVAL_CONFIG_ROUTE + id, item);
};
